
import {Injectable} from "@angular/core";

import {tap} from 'rxjs/operators';

import {ReplaySubject, Observable} from "rxjs";

import {SERVER_URL} from "../../config";

import {Storage} from "@ionic/storage";

import {HttpClient,HttpHeaders} from "@angular/common/http";

import {JwtHelperService} from "@auth0/angular-jwt";



@Injectable()

export class AuthProvider {

  private jwtTokenName = 'jwt_token';



  authUser = new ReplaySubject<any>(1);



  constructor(private readonly httpClient: HttpClient,

              private readonly storage: Storage,

              private readonly jwtHelper: JwtHelperService) {

  }



  checkLogin() {

    this.storage.get(this.jwtTokenName).then(jwt => {

      if (jwt && !this.jwtHelper.isTokenExpired(jwt)) {

        this.httpClient.get(`${SERVER_URL}/users/authenticate`)

          .subscribe(() => this.authUser.next(jwt),

            (err) => this.storage.remove(this.jwtTokenName).then(() => this.authUser.next(null)));

        // OR

        // this.authUser.next(jwt);

      }

      else {

        this.storage.remove(this.jwtTokenName).then(() => this.authUser.next(null));

      }

    });

  }



  login(values: any): Observable<any> {
    console.log(values.username);
    let postData = new FormData();
    postData.append('username' , values.username);
    postData.append('password' , values.password);


    return this.httpClient.post(`${SERVER_URL}/users/signin`,postData, {responseType: 'text'}).pipe(tap(jwt => this.handleJwtResponse(jwt)));

  }



  logout() {

    this.storage.remove(this.jwtTokenName).then(() => this.authUser.next(null));

  }



  signup(values: any): Observable<any> {
    let postData = new FormData();
    postData.append('username' , values.username);
    postData.append('password' , values.password);
    postData.append('email' , values.email);
    this.storage.get('fcmtoken').then( tk => {
      alert(tk);
      postData.append('fcmtoken' , tk);

      // expected output: Array [1, 2, 3]
    });
    

   // values.roles=[1];

    console.log(values)
   
    console.log(JSON.stringify(values)) ;

    
    return this.httpClient.post(`${SERVER_URL}/users/signup`, postData, {responseType: 'text'})
    // return this.httpClient.post(`${SERVER_URL}/users/in`, JSON.stringify(values), {responseType: 'text'})
      .pipe(tap(jwt => {

        if (jwt !== 'EXISTS') {

          return this.handleJwtResponse(jwt);

        }

        return jwt;

      }));

  }



  private handleJwtResponse(jwt: string) {
    console.log("JWT:");
    console.log(JSON.stringify(jwt));

    return this.storage.set(this.jwtTokenName, jwt)

      .then(() => this.authUser.next(jwt))

      .then(() => jwt);

  }
 
  public getHttpHeaders():HttpHeaders{
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    console.log("jwt header:"+JSON.stringify(this.storage.get(this.jwtTokenName)));
    headers.set("Access-Control-Allow-Origin", "*");
    headers.set('Authorization', 'Bearer ' + this.storage.get(this.jwtTokenName));  
    console.log('Authorization:'+headers.get('Authorization'))  
    return headers;  
  }


}


// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts